export default __webpack_public_path__ + "static/media/keyboard.e8e97f07.svg";